import { useNavigate } from 'react-router-dom';
import Modal from '@/components/common/Modal';
import Button from '@/components/common/Button';

interface UpgradeModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
}

export default function UpgradeModal({
  isOpen,
  onClose,
  title = 'Unlock Analytics',
  message = 'See who is visiting your pages, track link clicks, and monitor traffic sources. Upgrade your plan to access analytics.',
}: UpgradeModalProps) {
  const navigate = useNavigate();

  const handleViewPlans = () => {
    onClose();
    navigate('/app/subscription');
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <div className="flex flex-col items-center text-center">
        {/* Icon */}
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary-100">
          <svg
            className="h-7 w-7 text-primary-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z"
            />
          </svg>
        </div>

        {/* Title */}
        <h2 className="text-lg font-semibold text-neutral-900">{title}</h2>

        {/* Message */}
        <p className="mt-2 text-sm text-neutral-600">{message}</p>

        {/* Actions */}
        <div className="mt-6 flex w-full flex-col gap-2">
          <Button variant="primary" size="md" onClick={handleViewPlans} className="w-full">
            View Plans
          </Button>
          <Button variant="ghost" size="md" onClick={onClose} className="w-full">
            Maybe Later
          </Button>
        </div>
      </div>
    </Modal>
  );
}
